import { portfolio } from "@/mocks/portfolio";

const displayCategoryOrder = ["Exterior", "Interior", "Commercial", "Repair"];
const curatedProjectIds = [74, 76, 120, 122, 31, 30, 10, 11];
const curatedProjects = curatedProjectIds.map((id) => portfolio.find((p) => p.id === id)).filter(Boolean);

export default function PortfolioSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12 md:mb-16">
          <div>
            <div className="inline-flex items-center border border-foreground-300 rounded-full px-5 py-1.5 text-xs font-medium tracking-wider uppercase text-foreground-600 mb-6">
              Portfolio
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-foreground-950">
              Recent Projects
            </h2>
          </div>
          <p className="text-foreground-600 max-w-sm text-sm md:text-base">
            Browse our gallery of completed painting projects across Southern California.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {curatedProjects.map((project) => (
            <a
              key={project.id}
              href={`/portfolio?category=${encodeURIComponent(project.category)}`}
              className="group relative rounded-xl overflow-hidden aspect-[4/5] cursor-pointer block"
            >
              <img
                src={project.image}
                alt={project.title}
                className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="absolute top-3 right-3">
                <span className="bg-accent-500 text-background-50 text-xs font-medium px-3 py-1 rounded-full">
                  {project.category}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="/portfolio"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-background-100 text-foreground-700 hover:bg-background-200 text-sm font-medium tracking-wide uppercase transition-all whitespace-nowrap"
          >
            View All Projects
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}